<template>
  <v-row>
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn outlined color="grey darken-2" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
              <app-modal-insert-meeting
                v-if="
                  isFullAdmin || (config.novoEvento && groupsConfig.novoEvento)
                "
                :dialog="dialog"
                :meetings="events"
                @onSave="getMeetings"
              ></app-modal-insert-meeting>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Diária</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semanal</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mensal</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          locale="pt-BR"
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="'blue'"
          :event-more-text="'Ver mais eventos'"
          :event-end="'fim'"
          :event-name="'nome'"
          :event-start="'inicio'"
          :now="today"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        >
        </v-calendar>
        <app-modal-edit-meeting
          :dialogEdicao="dialogEdicao"
          :payload="selectedEvent"
          :meetings="events"
          @onSave="getMeetings"
          @closeDialog="closeEdicaoDialog"
        >
        </app-modal-edit-meeting>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { meetingAPI } from "@/modules/calendar";
import { eventAPI } from "@/modules/event";
import AppModalInsertMeeting from "./ModalInsertMeeting";
import AppModalEditMeeting from "./ModalEditMeeting";
import moment from "moment";

export default {
  components: {
    AppModalInsertMeeting,
    AppModalEditMeeting,
  },
  data() {
    return {
      municipioId: this.$route.params.id,
      focus: "",
      type: "month",
      typeToLabel: {
        month: "Mensal",
        week: "Semanal",
        day: "Diária",
      },
      start: null,
      end: null,
      selectedEvent: {
        nome: null,
        grupoId: 0,
        municipioId: this.$route.params.id,
        solucoesEvento: [],
        tarefasEvento: [],
        convidadosEvento: [],
        duracaoString: this.duracao,
        novaTarefa: {},
        encontroType: "Parcial",
      },
      selectedElement: null,
      selectedOpen: false,
      events: [],
      today: null,
      date: null,
      time: null,
      dialog: false,
      dialogEdicao: false,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  computed: {
    ...mapGetters(["loading", "isFullAdmin", "isAT"]),

    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const startMonth = this.monthFormatter(start);
      const startYear = start.year;
      const startDay = start.day + this.nth(start.day);

      switch (this.type) {
        case "month":
          return `${startMonth} ${startYear}`;
        case "week":
        case "day":
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return "";
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long",
      });
    },
  },
  mounted() {
    this.$refs.calendar.checkChange();
    this.getMeetings();
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
  },
  methods: {
    ...mapActions(["setLoading", "setAnalistaMunicipio", "setADMunicipio"]),
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      this.dialogEdicao = true;
      this.selectedEvent = {
        ...this.selectedEvent,
        ...event,
        duracaoString: this.duracao(event.inicioString, event.fimString),
      };
    },
    duracao(inicio, fim) {
      var diff = moment(fim, "DD/MM/YYYY HH:mm").diff(
        moment(inicio, "DD/MM/YYYY HH:mm"),
        "seconds"
      );

      diff = moment
        .utc(moment.duration(diff, "seconds").asMilliseconds())
        .format("HH:mm");

      return diff;
    },

    updateRange({ start, end }) {
      this.start = start;
      this.end = end;
    },
    nth(d) {
      return d > 3 && d < 21
        ? "th"
        : ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][d % 10];
    },
    getMeetings() {
      this.setLoading(true);
      this.dialogEdicao = false;
      meetingAPI
        .getByCity(this.municipioId)
        .then((resp) => {
          this.events = resp.data;
          eventAPI
            .getByFilter({ municipioId: this.municipioId })
            .then((response) => {
              let meetings = response.data;
              for (let count = 0; count < meetings.length; count++) {
                this.events.push(meetings[count]);
              }
              this.setLoading(false);
            })
            .catch((response) => {
              this.setLoading(false);
              this.$notification.error("Erro ao buscar eventos");
            });
        })
        .catch((resp) => {
          this.setLoading(false);
          if (this.isAT) this.$notification.error("Erro ao buscar agendas");
          else this.$notification.error("Erro ao buscar encontros");
        });
    },
    closeEdicaoDialog() {
      this.dialogEdicao = false;
    },
  },
};
</script>
